import React from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import ToastViewport from "../shared/ToastViewport";

const AdminLayout: React.FC = () => {
  return (
    <div className="app-shell admin-app-shell">
      <ScrollToTop />
      <main>
        <Outlet />
      </main>
      <ToastViewport className="admin-toast-viewport" durationMs={2000} />
    </div>
  );
};

export default AdminLayout;
